import { Stack } from '@mui/material';
import { Suspense } from 'react';

import { CircularBackdrop } from '../components/common/circularBackdrop/circularBackdrop';
import { Footer } from '../components/footer/footer';
import { Header } from '../components/header/header';
import { LandingPage } from '../components/landingPage/landingPage';

const LandingPageRoute = () => {
  return (
    <Suspense fallback={<CircularBackdrop />}>
      <Stack
        height="100%"
        minHeight="83vh"
        width="100%"
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={0}
      >
        <Header />
        <LandingPage />
        <Footer />
      </Stack>
    </Suspense>
  );
};

export default LandingPageRoute;
